export const StoreHero: React.FC = () => (
  <section className="relative overflow-hidden min-h-[580px] flex items-center">
    {/* Background image */}
    <div className="absolute inset-0">
      <img
        src="https://public.readdy.ai/ai/img_res/93cd53257f2dc042fa1b4d5a60011f60.jpg"
        alt="Store hero background"
        className="w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/65 to-black/30"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
    </div>

    <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
      <div className="max-w-2xl">
        {/* Badge */}
        <div className="inline-flex items-center bg-white/10 border border-white/20 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
          <i className="ri-store-2-line text-teal-300 mr-2 text-sm"></i>
          <span className="text-sm font-medium text-white/90">Official Store — Books &amp; Phone Apps</span>
        </div>

        {/* Heading */}
        <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Knowledge &amp; Tools<br />
          <span className="text-teal-300">That Drive Results</span>
        </h1>

        <p className="text-lg text-white/75 mb-10 leading-relaxed max-w-xl">
          Jeffery Long&apos;s complete collection of published books and exclusive phone apps — designed to help you invest smarter, automate faster, and live better.
        </p>

        {/* CTA buttons */}
        <div className="flex flex-wrap gap-4 mb-12">
          <a
            href="#books"
            className="inline-flex items-center bg-white text-gray-900 px-7 py-3.5 rounded-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line mr-2"></i>
            Browse Books
          </a>
          <a
            href="#apps"
            className="inline-flex items-center border-2 border-white/50 text-white px-7 py-3.5 rounded-lg font-bold hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            <i className="ri-smartphone-line mr-2"></i>
            Browse Apps
          </a>
        </div>

        {/* Stats */}
        <div className="flex flex-wrap gap-6">
          {[
            { icon: 'ri-book-2-line', label: '16 Books', sub: 'Published titles' },
            { icon: 'ri-smartphone-line', label: '25 Apps', sub: 'iPhone & Apple Watch' },
            { icon: 'ri-shield-check-line', label: 'Secure Checkout', sub: 'GoDaddy Payments' },
          ].map(({ icon, label, sub }) => (
            <div key={label} className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-white/10 border border-white/20 rounded-lg backdrop-blur-sm">
                <i className={`${icon} text-teal-300 text-lg`}></i>
              </div>
              <div>
                <div className="font-bold text-white text-sm">{label}</div>
                <div className="text-white/50 text-xs">{sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
